// Voxiox Design Tokens — Resona "warm blueprint" (portable of cipherpush ADR-0010)
// Warm dark ops-console palette. Colour is reserved for meaning:
//   green = E2EE/online/ok · terracotta = error/missed · gold = pending/unverified · blue = info
// Token names are kept from the old light theme (gray900 = ink, white = surface, …)
// so every existing import keeps working — only the values changed.

// ─── Typography ────────────────────────────────────────────
export const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
export const SERIF = "'New York', 'Iowan Old Style', 'Palatino', Georgia, serif";
export const MONO = "ui-monospace, 'SF Mono', 'Menlo', 'Roboto Mono', monospace";

// ─── Colors (warm dark) ────────────────────────────────────
export const colors = {
  // Ink scale (text): gray900 = primary ink … gray400 = muted
  gray900: '#ece9e6',
  gray800: '#d9d5d0',
  gray700: '#bcb7b1',
  gray600: '#a49e97',
  gray500: '#8d8780',
  gray400: '#78726b',
  // Surface scale (backgrounds): gray50 = page, white = card, gray100 = elevated
  gray300: 'rgba(255,255,255,0.14)',  // strong hairline
  gray200: 'rgba(255,255,255,0.08)',  // hairline borders
  gray100: '#211f29',                 // elevated surface / inputs
  gray50:  '#15141a',                 // page base
  white:   '#1b1a22',                 // card surface

  // Severity accents — the ONLY saturated colours in the system
  green:      '#4fb68c',                    // ok / E2EE / online
  greenLight: 'rgba(79,182,140,0.10)',
  greenBorder:'rgba(79,182,140,0.35)',
  greenDot:   '#4fb68c',

  red:        '#dd7a5c',                    // terracotta: error / missed / decline
  redLight:   'rgba(221,122,92,0.10)',

  amber:      '#deac4a',                    // gold: pending / unverified / reconnecting

  // Info blue (chat bubbles, links)
  bubbleBlue: 'rgba(110,138,208,0.20)',
  avatarBlue: '#6e8ad0',

  // Brand (use sparingly)
  telegram:   '#6e8ad0',
};

// Blueprint chrome
export const dot = 'rgba(255,255,255,0.05)';        // dotted-grid dots
export const eyebrow = {
  fontSize: 11, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase',
  color: colors.gray500,
};

// ─── Border Radius ─────────────────────────────────────────
export const radii = {
  sm:   8,
  md:   12,
  lg:   16,
  xl:   20,
  xxl:  24,
  full: 9999,
};

// ─── Shadows (dark: depth via darker, wider umbra) ─────────
export const shadows = {
  sm:  '0 1px 2px rgba(0,0,0,0.4)',
  md:  '0 4px 10px -2px rgba(0,0,0,0.5)',
  lg:  '0 10px 24px -6px rgba(0,0,0,0.55)',
  xl:  '0 25px 50px -12px rgba(0,0,0,0.7)',
};

// ─── Spacing ───────────────────────────────────────────────
export const spacing = {
  xs:  4,
  sm:  8,
  md:  12,
  lg:  16,
  xl:  20,
  xxl: 24,
  xxxl:32,
};
